// extracted by mini-css-extract-plugin
export default {"alert":"vacation-alert_alert__wWSuz","icon":"vacation-alert_icon__to0Pr","content":"vacation-alert_content__-gKWK","link":"vacation-alert_link__PPXcs"};